import { create } from "zustand";

import type { ConnectionStatus } from "./socket";

type RealtimeState = {
  status: ConnectionStatus;
  /** When the socket last came up. Null until the first successful connect. */
  connectedAt: number | null;
  setStatus: (status: ConnectionStatus) => void;
};

/**
 * Connection state lives in Zustand rather than in React context because it
 * changes on its own schedule, several times a minute on a bad network, and a
 * context would re-render every consumer of the app tree each time.
 */
export const useRealtimeStore = create<RealtimeState>((set) => ({
  status: "connecting",
  connectedAt: null,
  setStatus: (status) =>
    set((previous) => ({
      status,
      connectedAt: status === "open" ? Date.now() : previous.connectedAt,
    })),
}));
